(function() {
	document.getElementById("submit-btn")
	.addEventListener("click", function() {

		const radios = document.getElementsByClassName("js-addon-radio");
		const groups = [];

		for (let i = 0; i < radios.length; i++) {
			
			const grpIndex = groups.findIndex(
				(g) => g.id == radios[i].dataset.grpId
			);

			if (grpIndex === -1) {
				groups.push({
					id: radios[i].dataset.grpId,
					slug: radios[i].dataset.grpSlug,
					selected: radios[i].checked
				});
			}
			else {

				if ( radios[i].checked ) {
					groups[grpIndex].selected = true;
				}
			}

		}

		for (let i = 0; i < groups.length; i++) {
			
			if ( ! groups[i].selected ) {

				const title = document.getElementById(groups[i].slug);
				title.parentElement.getElementsByClassName("error")[0]
					.classList.remove("hidden");

				title.scrollIntoView({ behavior: "smooth" });

				return false;
			}
		}

		document.getElementById("main-loading")
			.classList.remove("hidden");

		document.getElementById("subscription-form").submit()
	});
})()